import {
  FETCH_MONTHLY_EXCHANGE_RATE_REQUEST,
  FETCH_MONTHLY_EXCHANGE_RATE_SUCCESS,
  FETCH_MONTHLY_EXCHANGE_RATE_FAILURE,
  FETCH_YEARLY_EXCHANGE_RATE_REQUEST,
  FETCH_YEARLY_EXCHANGE_RATE_SUCCESS,
  FETCH_YEARLY_EXCHANGE_RATE_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {};

export const exchangeRateDynamics = createReducer(initialState, {
  [FETCH_MONTHLY_EXCHANGE_RATE_REQUEST]: state => ({
    ...state,
  }),

  [FETCH_MONTHLY_EXCHANGE_RATE_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.slugKey]: {
      ...(state[action.payload.slugKey] || {}),
      [action.payload.typeKey]: action.payload.rates,
    },
  }),

  [FETCH_MONTHLY_EXCHANGE_RATE_FAILURE]: state => ({
    ...state,
  }),

  [FETCH_YEARLY_EXCHANGE_RATE_REQUEST]: state => ({
    ...state,
  }),

  [FETCH_YEARLY_EXCHANGE_RATE_SUCCESS]: (state, action) => ({
    ...state,
    [action.payload.slugKey]: {
      ...(state[action.payload.slugKey] || {}),
      [action.payload.typeKey]: action.payload.rates,
    },
  }),

  [FETCH_YEARLY_EXCHANGE_RATE_FAILURE]: state => ({
    ...state,
  }),
});

export default exchangeRateDynamics;
